export default "__VITE_ASSET__9dd7e4ae__"